module.exports = __webpack_public_path__ + "img/no-data.9d50c60f.png";